import { render, staticRenderFns } from "./association-goods.vue?vue&type=template&id=14124116&scoped=true&"
import script from "./association-goods.vue?vue&type=script&lang=js&"
export * from "./association-goods.vue?vue&type=script&lang=js&"
import style0 from "./association-goods.vue?vue&type=style&index=0&id=14124116&prod&lang=scss&"
import style1 from "./association-goods.vue?vue&type=style&index=1&id=14124116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14124116",
  null
  
)

export default component.exports